import type { ArticleCategoryCard } from '@/lib/articles';

interface Props {
  categories: ArticleCategoryCard[];
  activeCategory: string;
  onSelect: (name: string) => void;
}

const CategoryCards = ({ categories, activeCategory, onSelect }: Props) => {
  return (
    <div className="max-w-7xl mx-auto px-6 py-8">
      <div className="flex items-center gap-2 mb-5">
        <div className="w-1 h-5 bg-[#0A1628] rounded-full" />
        <h2 className="text-sm font-bold text-[#0A1628] tracking-wide uppercase">瀏覽分類</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {categories.map((cat) => {
          const isActive = activeCategory === cat.name;
          return (
            <button
              key={cat.id}
              onClick={() => onSelect(cat.name)}
              className={`relative cursor-pointer rounded-xl p-4 text-left transition-all duration-200 group overflow-hidden whitespace-nowrap ${
                isActive ? 'ring-2 ring-offset-1 ring-[#0A1628] scale-[1.02]' : 'hover:-translate-y-0.5'
              }`}
              style={{ background: isActive ? '#0A1628' : '#F1F3F8' }}
            >
              {!isActive ? (
                <div className={`absolute inset-0 bg-gradient-to-br ${cat.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-200 rounded-xl`} />
              ) : null}
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg mb-3 ${isActive ? 'bg-white/15' : `bg-gradient-to-br ${cat.gradient}`}`}>
                <i className={`${cat.icon} text-lg text-white`} />
              </div>
              <p className={`text-sm font-bold mb-0.5 ${isActive ? 'text-white' : 'text-[#0A1628]'}`}>{cat.name}</p>
              <p className={`text-[11px] leading-snug ${isActive ? 'text-white/60' : 'text-slate-500'}`}>{cat.description}</p>
              <p className={`text-[11px] font-semibold mt-2 ${isActive ? 'text-white/70' : 'text-slate-400'}`}>{cat.count} 篇文章</p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryCards;
